import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider } from 'firebase/auth'; // Import Auth and GoogleAuthProvider

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBt9HO6bH4Dhuf45FoMO1VQiOx1PQW-B68",
  authDomain: "powergames-76685.firebaseapp.com",
  projectId: "powergames-76685",
  storageBucket: "powergames-76685.appspot.com",
  messagingSenderId: "726412896180",
  appId: "1:726412896180:web:5ea4aea480706abd74f4e1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Storage
const storage = getStorage(app);

// Initialize Firebase Authentication and Google Auth Provider
const auth = getAuth(app);
const provider = new GoogleAuthProvider(); // Set up Google authentication provider

export { db, storage, auth, provider }; // Export auth and provider
